import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';

import styles from './hourly-forecast.module.css';

export default function HourlyForecast({ handleWeatherClick, nextHours }) {
    return (
        <div className={styles.hourlyForecast}>
        <Typography variant="subtitle1" className={styles.forecastTitle}>
          8-Hour Forecast (Starting Next Hour)
        </Typography>
        <div className={styles.hourlyGrid}>
          {nextHours.map((hour, index) => {
            const hourTime = dayjs()
              .tz('America/Toronto')
              .hour(parseInt(hour.time.split(':')[0]));
            
            return (
              <div 
                key={index} 
                className={`${styles.hourlyItem} ${styles.clickable}`}
                onClick={() => handleWeatherClick({ ...hour, time: hourTime.format('h A') })}
              >
                <Typography variant="body2" className={styles.hourTime}>
                  {hourTime.format('h A')}
                </Typography>
                <Typography variant="h6" className={styles.hourTemp}>
                  {hour.temperature}°
                </Typography>
                <Typography variant="body2" className={styles.hourlyCondition}>
                  {hour.conditions}
                </Typography>
                {hour.precipitation?.probability > 0 && (
                  <Typography variant="caption" className={styles.precipInfo}>
                    Chance of {hour.precipitation.type || 'precipitation'}: {hour.precipitation.probability}%
                  </Typography>
                )}
              </div>
            );
          })}
        </div>
      </div>
    )
}